module.exports = __webpack_public_path__ + "img/24h.cbe0110a.png";